import _ from 'lodash/fp';
import GraniteError from 'granite-admin/utils/granite-error';
class Permission {
  constructor({
    pk,
    name,
    display_text,
    display_section,
    access_type,
    is_active,
    is_deleted
  }) {
    if (_.isNil(pk) || _.isNil(name) || !_.isString(name)) {
      throw new GraniteError('Permission must have name and pk');
    }
    this.pk = pk;
    this.name = name;
    this.displayText = display_text;
    this.displaySection = display_section;
    this.accessType = access_type;
    this.isActive = is_active;
    this.isDeleted = is_deleted;
  }
}
export default Permission;